import Imgix from 'react-imgix';
import ProductPriceFormat from '../../../products/product-price/product-price-format';
import React, { useEffect, useRef } from 'react';
import { ICartItem } from '../../../shopping-cart/cart-bridger-pay/interfaces';
import { IStoreProps } from '../index';

interface ICartItemProps {
    cartItem: ICartItem;
    storeProps: IStoreProps;
}

const CartItem = ({ cartItem, storeProps }: ICartItemProps) => {

    const itemRef = useRef<HTMLDivElement>(null);

    const { useAppSelector } = storeProps;
    const selectedItemGuid = useAppSelector(store => store.root.selectedItemGuid);

    useEffect(() => {
        if(selectedItemGuid !== cartItem.cartItemGUID) return;

        setTimeout(() => {
            itemRef.current?.focus();
        }, 150);
    } ,[selectedItemGuid, cartItem.cartItemGUID]);

    return (
        <div
            ref={ itemRef }
            tabIndex={0}
            className={`grid top-mini-cart__grid gap-4 mb-4 text-gray-700 items-center`}
            style={{
                height: '80px',
            }}
        >
            <div className="bg-gray-150 flex items-center justify-center mr-3 p-3">
                <Imgix
                    src={cartItem.skuThumb}
                    width={60}
                    htmlAttributes={{
                        alt: `Image for ${cartItem.skuName}`,
                        loading: 'lazy',
                    }}
                />
            </div>

            <div className="font-medium">
                {cartItem.skuName}
            </div>

            <div className="text-gray-500">x{cartItem.skuUnits}</div>

            <div className="font-medium text-right">
                <ProductPriceFormat price={cartItem.priceData.priceAfterDiscount}/>
            </div>
        </div>
    )
};

export default CartItem;